<template>
  <div>
    <el-row id="content-title">
      <el-col :span="24">
        <div class="d-flex align-items-center">
          <h3 class="mb-0">Repair</h3>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="bg-white p-2">
          <ul class="list-unstyled" style="margin-bottom: 0">
            <li v-for="(item, index) in routes" :key="index">
              <router-link v-if="!item.children" :to="{ name: item.name }">{{
                item.meta.menu.name
              }}</router-link>
              <router-link v-else :to="{ name: item.children[0].name }">{{
                item.meta.menu.name
              }}</router-link>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "list",

  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },
    routes() {
      let routes = this.$router.options.routes[0].children
        .find(o => o.path == "/repair")
        .children.filter(
          route =>
            route.hasOwnProperty("meta") && route.meta.hasOwnProperty("menu")
        );

      let submenus = [];
      for (let child of routes) {
        if (
          child.meta.hasOwnProperty("userType") &&
          typeof child.meta.userType == "number"
        ) {
          if (this.user.user_type == child.meta.userType) submenus.push(child);
        } else if (
          child.meta.hasOwnProperty("userType") &&
          typeof child.meta.userType == "object"
        ) {
          if (
            child.meta.userType.find(o => {
              return o == this.user.user_type;
            })
          )
            submenus.push(child);
        } else {
          submenus.push(child);
        }
      }

      let sorted = submenus.sort((a, b) => {
        if (a.meta.menu.name < b.meta.menu.name) return -1;
        if (a.meta.menu.name > b.meta.menu.name) return 1;
        return 0;
      });

      return sorted;
    }
  },
  methods: {
    roleCheck(role) {
      if (this.user.user_type == role) return true;
      return false;
    }
  }
};
</script>

<style lang="css" scoped></style>
